import React, { useState } from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import ListingTitle from "~components/pages/listing/listing-title/listing-title"
import WidgetListingDetailsLeftColumn from "~widget/components/widget-listing-details/widget-listing-details-left-column"
import WidgetListingDetailsRightColumn from "~widget/components/widget-listing-details/widget-listing-details-right-column"
import WidgetListingPackagesDrawer from "~widget/components/widget-listing-details/widget-listing-packages-drawer"
import DetailsBoxMobile from "~components/pages/listing/details-box-mobile"
import Box from "~components/shared/todo-lib-react-components/box"
import RestoreCheckoutSessionModal from "~widget/components/widget-listing-details/restore-checkout-session-modal"

export default function WidgetListingDetails() {
    const styles = useStyles()
    const { listing } = useCheckoutFlow()
    const [drawerIsOpen, setDrawerIsOpen] = useState(false)

    return (
        <>
            <ListingTitle
                listing={listing!}
                isOwner={false}
                shouldHideButtons
                noPadding
            />

            <Box style={styles.columns}>
                <WidgetListingDetailsLeftColumn />
                <WidgetListingDetailsRightColumn />
            </Box>

            {/* Listing packages drawer */}
            <DetailsBoxMobile
                listing={listing!}
                setDrawerIsOpen={setDrawerIsOpen}
            />
            <WidgetListingPackagesDrawer
                isOpen={drawerIsOpen}
                onClose={() => setDrawerIsOpen(false)}
            />
            <RestoreCheckoutSessionModal listingId={listing?.id} />
        </>
    )
}

function useStyles() {
    return componentStyles({
        columns: {
            flexDirection: { base: "column-reverse", md: "row" },
            gap: "30px",
            display: "flex",
            marginTop: "20px",
        },
    })
}
